<h3 class="title configurator-title">{{ 'decking-boards.accessories.title' | translate }}</h3>

<div class="config-container shadow" *ngIf="accessories != undefined && accessories.length > 0">
  <h4 class="title configurator-subtitle">{{ 'decking-boards.accessories.accessories' | translate }}</h4>

  <div class="configurator-cards-container blocked-size" *ngIf="accessories !== undefined">
    <div
      class="configurator-card"
      [ngClass]="{ active: isAccessorySelected(accessory.id) }"
      *ngFor="let accessory of displayAccessories()"
      (click)="selectAccessory(accessory)">
      <img [src]="baseImgURL + accessory.ean.icon" alt="shape-img" class="configurator-card-img" />
      <p class="configurator-card-title" *ngIf="currentLang === 'fr'">{{ accessory.ean.nameFr }}</p>
      <p class="configurator-card-title" *ngIf="currentLang === 'en'">{{ accessory.ean.nameEn }}</p>
    </div>
    <ng-casto-loader *ngIf="accessories === undefined"></ng-casto-loader>
  </div>
</div>

<div class="config-container shadow mt-4">
  <!-- Liste des outils et consommables -->
  <h4 class="title configurator-subtitle">{{ 'decking-boards.accessories.supplies' | translate }}</h4>

  <div class="configurator-cards-container">
    <ul class="supply-list" *ngIf="currentLang === 'fr'">
      <li *ngFor="let supply of supplies">{{ supply.nameFr }}</li>
    </ul>

    <ul class="supply-list" *ngIf="currentLang === 'en'">
      <li *ngFor="let supply of supplies">{{ supply.nameEn }}</li>
    </ul>
  </div>
</div>
